"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_USER_PROPERTY = exports.SET_TOKEN = exports.SET_SESSION = exports.SET_FEATURE_FLAGS = exports.SET_ACTIVE_ORGANIZATION = exports.INCREASE_PROFILE_ASSETS_COUNT = exports.DECREASE_PROFILE_ASSETS_COUNT = void 0;
var SET_SESSION = exports.SET_SESSION = 'Set session';
var SET_TOKEN = exports.SET_TOKEN = 'Set token';
var SET_USER_PROPERTY = exports.SET_USER_PROPERTY = 'Set user property';
var SET_FEATURE_FLAGS = exports.SET_FEATURE_FLAGS = 'Feature flags initialized';
var INCREASE_PROFILE_ASSETS_COUNT = exports.INCREASE_PROFILE_ASSETS_COUNT = 'Increase profile assets count';
var DECREASE_PROFILE_ASSETS_COUNT = exports.DECREASE_PROFILE_ASSETS_COUNT = 'Decrease profile assets count';
var SET_ACTIVE_ORGANIZATION = exports.SET_ACTIVE_ORGANIZATION = 'Set active organization';
//# sourceMappingURL=actionTypes.js.map